import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lightbox"
export default class extends Controller {
  open() {
    const url = this.element.href;
    const dialog = document.createElement("dialog");

    dialog.innerHTML = `<img src="${url}" class="w-auto h-auto max-w-6xl max-h-6xl" />`;
    document.body.appendChild(dialog);

    dialog.addEventListener("close", () => {
      dialog.remove();
    });

    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.showModal();
  }
}
